import React from 'react'
import PropTypes from 'prop-types'

import './LoadingScreen.scss'

/**
 * Primary UI component for user interaction
 */
export const LoadingScreen = ({ message, ...props }) => {
  return (
    <div className={'m-loader'}>
      <div className="m-loader__spinner">
        <div/><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/>
      </div>

      {message ? <div className={'m-loader__message'}>{message}</div> : null}
    </div>
  )
}

LoadingScreen.propTypes = {
  message: PropTypes.string,
}